<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" :class="[`${prefix}-icon`, `${prefix}-icon-wxyy`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_39de7435e5__a"><rect width="16" height="16" rx="0"/></clipPath></defs><g clip-path="url(#svg_39de7435e5__a)"><path d="M7.921873125,0.951171875L14.060503125,4.4951718750000005L14.060503125,11.584071875L7.921873125,15.128071875L1.783203125,11.584071875L1.783203125,4.4951718750000005L7.921873125,0.951171875ZM11.945903125,6.340501875L8.076533125000001,8.431171875L8.076533125000001,12.597371875L11.946803125,10.363611875L11.945903125,6.340501875ZM7.921873125,3.392061875L3.896983125,5.715611875L3.896983125,10.363611875L5.962753125,11.554771875L5.962753125,7.171611875L10.355643125,4.798281875L7.921873125,3.393841875L7.921873125,3.392061875Z" :fill="useCurrentColor ? 'currentColor' : '#7367F0'"/></g></svg>
</template>
<script>

export default {
  name: 'IconWxyy',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
